import { useCallback, useState } from 'react';

export interface Accordion {
  isOpen: (key: string) => boolean;
  toggle: (key: string) => void;
}

/*
------------------------------------------------------------
Ramos abertos do acordeão
------------------------------------------------------------
Cada ramo abre e fecha por conta própria: abrir um não recolhe os irmãos, e
recolher o pai preserva o estado dos filhos — reabrir o pai devolve a árvore
como o usuário a deixou.
------------------------------------------------------------
*/
export const useAccordion = (): Accordion => {
  const [expanded, setExpanded] = useState<ReadonlySet<string>>(
    () => new Set(),
  );

  const isOpen = useCallback((key: string) => expanded.has(key), [expanded]);

  const toggle = useCallback((key: string) => {
    setExpanded((current) => {
      const next = new Set(current);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  }, []);

  return { isOpen, toggle };
};

export default useAccordion;
